import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MngFormData } from '../form/mng-form-control-group';
import {
  BaseDialogData,
  DIALOG_RESULT_CANCEL,
  DIALOG_RESULT_NO,
  DIALOG_RESULT_OK,
  DIALOG_RESULT_YES,
  DialogType
} from './mng-dialog.types';
import { MatButton } from '@angular/material/button';
import { MatInput } from '@angular/material/input';
import { MatError, MatFormField } from '@angular/material/form-field';
import { MngDatepickerComponent } from '../datepicker/mng-datepicker.component';
import { MngDialogHeaderComponent } from './dialog-header/mng-dialog-header.component';

@Component({
  imports: [
    MngDialogHeaderComponent,
    MatDialogContent,
    MngDatepickerComponent,
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatError,
    MatDialogActions,
    MatButton
  ],
  templateUrl: './mng-base-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class MngBaseDialogComponent {
  data = inject<BaseDialogData>(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<MngBaseDialogComponent>>(MatDialogRef);

  formControl: FormControl = new FormControl();
  formData: MngFormData;

  resultValueOk = DIALOG_RESULT_OK;
  resultValueNo = DIALOG_RESULT_NO;
  resultValueYes = DIALOG_RESULT_YES;
  resultValueCancel = DIALOG_RESULT_CANCEL;

  onFocus(event) {
    if (this.data.autoselect) {
      event.target.select();
    }
  }

  get isDateInput(): boolean {
    return this.data.dialogType === DialogType.TextInputAsDate;
  }

  get yesButton(): boolean {
    return this.data.dialogType === DialogType.YesNo;
  }

  get noButton(): boolean {
    return this.data.dialogType === DialogType.YesNo;
  }

  get cancelButton(): boolean {
    return (
      (this.data.dialogType === DialogType.TextInput || this.data.dialogType === DialogType.TextInputAsDate) &&
      this.data.cancelEnabled
    );
  }

  get okButton(): boolean {
    return this.data.dialogType === DialogType.Ok || this.showInput;
  }

  get showInput(): boolean {
    return this.data.dialogType === DialogType.TextInput || this.data.dialogType === DialogType.TextInputAsDate;
  }

  isFormInvalid(): boolean {
    return this.formControl.invalid || (!!this.formData && !this.formData.valid);
  }

  onEnter(value: string) {
    if (this.isFormInvalid()) {
      return;
    }
    this.dialogAction(value);
  }

  dialogAction(value: string): void {
    if (this.showInput && DIALOG_RESULT_OK === value) {
      this.dialogRef.close(this.formControl.value);
    } else {
      this.dialogRef.close(value);
    }
  }
}
